/**
 * MasteringToggle Component
 * Toggle for Mastering panel
 */

import React from 'react';
import { Button } from '../../ui/button';
import { Gauge } from 'lucide-react';

export const MasteringToggle = ({
  showMastering,
  setShowMastering,
  isSimplifiedMode = false,
}) => {
  if (isSimplifiedMode) return null;
  
  return (
    <Button
      variant={showMastering ? 'default' : 'ghost'}
      size="sm"
      onClick={() => setShowMastering(!showMastering)}
      className={`relative p-2 ${showMastering ? 'bg-amber-500/20 text-amber-400 border border-amber-500/50' : 'text-zinc-400 hover:text-white hover:bg-amber-500/20'}`}
      data-testid="mastering-btn"
      title="Mastering - LUFS metering & export presets"
    >
      <Gauge className="w-5 h-5" />
    </Button>
  );
};

export default MasteringToggle;
